import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DataTable, Column } from '../components/DataTable';
import { EditIcon, TrashIcon, PlusIcon } from 'lucide-react';
interface NegotiationRow {
  id: string;
  prNo: string;
  suppliersCount: number;
  date: string;
}
const initialNegotiations: NegotiationRow[] = [{
  id: 'NEG-001',
  prNo: 'PR-2023-001',
  suppliersCount: 3,
  date: '2023-10-25'
}, {
  id: 'NEG-002',
  prNo: 'PR-2023-001',
  suppliersCount: 2,
  date: '2023-10-26'
}, {
  id: 'NEG-003',
  prNo: 'PR-2023-002',
  suppliersCount: 4,
  date: '2023-10-28'
}];
export function NegotiationList() {
  const navigate = useNavigate();
  const [negotiations, setNegotiations] = useState(initialNegotiations);
  const handleDelete = (id: string) => {
    if (window.confirm('Are you sure you want to delete this negotiation?')) {
      setNegotiations(prev => prev.filter(n => n.id !== id));
    }
  };
  const columns: Column<NegotiationRow>[] = [{
    key: 'id',
    label: 'Negotiation ID',
    render: item => <span className="font-medium text-indigo-600" data-id="element-1361">{item.id}</span>
  }, {
    key: 'prNo',
    label: 'PR No'
  }, {
    key: 'suppliersCount',
    label: 'Suppliers'
  }, {
    key: 'date',
    label: 'Date'
  }];
  return <div className="space-y-6" data-id="element-1362">
      <div className="flex items-center justify-between" data-id="element-1363">
        <div data-id="element-1364">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1365">Negotiations</h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-1366">
            Manage supplier negotiations per PR item
          </p>
        </div>
        <button onClick={() => navigate('/negotiation/create')} className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-1367">
          <PlusIcon className="h-4 w-4 mr-2" data-id="element-1368" />
          Create Negotiation
        </button>
      </div>

      <DataTable data={negotiations} columns={columns} keyExtractor={row => row.id} onRowClick={row => navigate(`/negotiation/${row.id}`)} actions={row => <div className="flex items-center justify-end space-x-3" data-id="element-1370">
            <button onClick={() => navigate(`/negotiation/${row.id}`)} className="text-indigo-600 hover:text-indigo-900" title="Edit" data-id="element-1371">
              <EditIcon className="h-4 w-4" data-id="element-1372" />
            </button>
            <button onClick={() => handleDelete(row.id)} className="text-red-500 hover:text-red-700" title="Delete" data-id="element-1373">
              <TrashIcon className="h-4 w-4" data-id="element-1374" />
            </button>
          </div>} data-id="element-1369" />
    </div>;
}